import { DiagramModel } from "@projectstorm/react-diagrams";
import { selectedAutomationNode } from "../../Template/NewTemplateSignals";
import { AdaptiveNode } from "../Nodes/NodeFactory";

export const ApprovalDiagramModel = () => {
  const newModel = new DiagramModel();

  const TriggerNodeConstructor = AdaptiveNode("TriggerNode");
  const TriggerNode = new TriggerNodeConstructor({
    position: { x: 250, y: 125 },
    nodeProperties: { Name: "New Trigger Node", TriggerType: "Manual", Type: "Trigger" },
  });
  const onTriggerPort = TriggerNode.getPort("onTrigger");

  const ApprovalNodeConstructor = AdaptiveNode("EventNode");
  const ApprovalNode = new ApprovalNodeConstructor({
    position: { x: 450, y: 200 },
    nodeProperties: { Name: "New Event", Type: "Event", Event: "Send Approval" },
  });
  const EventPort = ApprovalNode.getPort("Event");
  const OnSendPort = ApprovalNode.getPort("OnSend");

  const TerminateNodeConstructor = AdaptiveNode("TerminateNode");
  const TerminateNode = new TerminateNodeConstructor({ position: { x: 750, y: 300 } });
  const EventPort2 = TerminateNode.getPort("Event");

  const link1 = onTriggerPort.link(EventPort);
  const link2 = OnSendPort.link(EventPort2);

  newModel.registerListener({
    selectionChanged: (event) => {
      const selectedNodes = event.isSelected;
      if (selectedNodes.length > 0) {
        const selectedNodeId = selectedNodes[0].getOptions().id;
        selectedAutomationNode.value = selectedNodeId;
      } else {
        selectedAutomationNode.value = null;
      }
    },
  });

  newModel.addAll(TriggerNode, ApprovalNode, TerminateNode, link1, link2);

  return {
    id: new Date().getTime(),
    name: "New Automation",
    model: newModel,
  };
};
